import makeApiRequest from './makeApiRequest';

export default async function fetchDocument(account, instance, documentID) {
    return await makeApiRequest(account, instance, 'get', 'GetDocument', {documentId: documentID});
}